module.exports = __webpack_public_path__ + "gxqgouche2212/static/img/banner.fb735283.jpg";